module.exports = __webpack_public_path__ + "static/media/2.e0ea51e5.jpg";